<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
    let { event } = $props();
import * as m from "@app/paraglide/messages.js";

function removeSpeaker(speaker){
event.speakers = event.speakers.filter(sp =>{
    return sp.id !== speaker.id;
});

insertHistoryAction({
    name: "remove speaker", //action name
    eventGroup: projectState.selected,
    snapshots: [{
        store: "eventGroupState",
        value: JSON.stringify(eventGroupState),
    }, ],
}); 
}
</script>

<div class="col-4">
    <div class="speakerWrapper">

        {#each event.speakers || [] as speaker}
            <span class="badge m-1 text-custom-small {speaker.colour === "yellow" ? 'text-black' : 'text-dark'}" style="background-color: {speaker.colour}">
                <a href="#!/"  onclick={() => removeSpeaker(speaker)} aria-label={m.event_speakers_remove_aria_label({name: speaker.name})} class="text-danger"><i class="bi bi-x"></i></a>
                {speaker.name}</span>
        {:else}
        <span class="text-custom-small text-muted">{m.event_speakers_no_speakers()}</span>
        {/each}
    </div>
</div>

<style lang="css">
.speakerWrapper {
    overflow-x: auto;
    white-space: nowrap;
}
</style>
